<template>
  <window-portal :open="dataProps.show" @close="onClose">
    <preview-document :config="previewConfig">
      <template #pages="{ config }">
        <!-- pages -->
        <preview-page
          v-for="(pageData, pIndex) in pagesData"
          :key="`page-${pIndex}`"
          :config="config"
        >
          <!-- page header -->
          <template #header>
            <div :style="style.page.header">
              <div>{{ dataProps.data.business.BusinessBillingName }}</div>
              <div>Libro Diario al {{ reportDate }}</div>
              <div v-if="dataProps.data.business.Currency == '$'">US DOLAR</div>
              <div :style="style.page.pageCount">
                Pág. {{ pIndex + 1 }}/{{ totalPages }}
              </div>
            </div>
          </template>

          <!-- page body -->
          <table :style="style.table.table">
            <thead>
              <tr>
                <th :style="{ ...style.table.headerLeft, ...style.w90 }">
                  Cuenta
                </th>
                <th :style="{ ...style.table.headerLeft, ...style.w140 }">
                  Nombre
                </th>
                <th :style="style.table.headerLeft">Concepto</th>
                <th :style="{ ...style.table.headerCenter, ...style.w100 }">
                  Cargo
                </th>
                <th :style="{ ...style.table.headerCenter, ...style.w100 }">
                  Abono
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(record, rIndex) in pageData"
                :key="`rec-${pIndex}-${rIndex}`"
              >
                <!-- accounting entry subheaders -->
                <template v-if="record.type === 'header'">
                  <td :style="style.table.subheader">
                    {{ record.data.accounting_entry_date }}
                  </td>
                  <td :style="style.table.subheader" colspan="4">
                    {{ record.data.ID_Accounting_item }}
                  </td>
                </template>

                <!-- accounting entries -->
                <template v-else-if="record.type === 'child'">
                  <td :style="style.table.data">
                    {{ record.data.account_code }}
                  </td>
                  <td :style="style.table.data">
                    {{ record.data.accounting_entry_name }}
                  </td>
                  <td :style="style.table.data">{{ record.data.concept }}</td>
                  <td :style="style.table.dataRight">{{ record.data?.Debe != 0 ? record.data?.Debe : '' }}</td>
                  <td :style="style.table.dataRight">
                    {{ record.data?.Haber != 0 ? record.data?.Haber : '' }}
                  </td>
                </template>

                <!-- accounting entries total -->
                <template v-else>
                  <td colspan="3" :style="style.table.subheaderRight">
                    Total Partida
                  </td>
                  <td :style="style.table.subheaderRight">
                    ${{ record.data.debe?.toFixed(2) }}
                  </td>
                  <td :style="style.table.subheaderRight">
                    ${{ record.data.haber?.toFixed(2) }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <template #footer>
          <div v-if="pIndex === totalPages - 1" :style="style.signatures">
            <div :style="style.leftSignature">
              <div>__________________________________</div>
              <div>{{ AccountantName  ?? 'Contador' }}</div>
              <div>{{ AccountantAdditional ?? '' }}</div>
              <div>{{ `${AccountantName ? 'Contador' : ''}` }}</div>
            </div>
            <div :style="style.rightSignature">
              <div>__________________________________</div>
              <div>{{ AuditorName ?? 'Auditor' }}</div>
              <div>{{ AuditorAdditional ?? '' }}</div>
              <div>{{ `${AuditorName ? 'Auditor' : ''}` }}</div>
            </div>
          </div>
          </template>
        </preview-page>
      </template>
    </preview-document>
  </window-portal>
</template>

<script>
import moment from "moment";
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import PreviewDocument from "@/components/PreviewDocument/PreviewDocument.vue";
import PreviewPage from "@/components/PreviewDocument/PreviewPage.vue";
import { page, table } from "@/components/PreviewDocument/styles.js";

export default {
  name: "PrintDailyBook",

  model: {
    event: "update",
    prop: "dataProps",
  },

  props: {
    dataProps: {
      type: Object,
      default: () => ({}),
    },
  },

  components: { WindowPortal, PreviewDocument, PreviewPage },

  data: () => ({
    loading: false,
    previewConfig: {
      title: "Vista Previa de Impresión de Libro Diario",
      filename: "LibroDiario.pdf",
      margins: [10, 10, 10, 20],
      unit: "mm",
      format: "letter",
      orientation: "portrait",
    },
    style: {
      page,
      table,
      w90: { width: "90px" },
      w100: { width: "100px" },
      w140: { width: "140px" },
      signatures: {
        display: 'flex',
        'padding-top': '35px',
        'font-size': '12px',
      },
      leftSignature: {
        width: '50%',
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center',
      },
      rightSignature: {
        width: '50%',
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center',
      },
    },
    maxRowsPerPage: 54,
    lastPageMaxRows: 45,
    pagesData: [[]],
    AccountantName: JSON.parse(localStorage.getItem("user")).AccountantName,
    AccountantAdditional: JSON.parse(localStorage.getItem("user")).AccountantAdditional,
    AuditorName: JSON.parse(localStorage.getItem("user")).AuditorName,
    AuditorAdditional: JSON.parse(localStorage.getItem("user")).AuditorAdditional,
  }),

  computed: {
    reportDate() {
      const { year, month } = this.dataProps.data.date;
      const lastDate = moment(`${year}-${month}-01`).endOf("month");
      let monthName = lastDate.format("MMMM");
      monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);

      return `${lastDate.format("DD")} de ${monthName} de ${year}`;
    },
    totalPages() {
      return this.pagesData.length;
    },
  },

  watch: {
    "dataProps.show"() {
      if (this.dataProps.show) {
        this.loading = true;
        setTimeout(async () => {
          this.calculatePagesOfDoc();
        }, 100);
      }
    },
  },

  methods: {
    onClose() {
      const dataProps = this.$clone(this.dataProps);
      dataProps.data.body = [];
      dataProps.show = false;
      this.$emit("update", dataProps);
      this.$emit("closed", false);
    },
    getRecordID(record) {
      const { accounting_entry_date, ID_Accounting_item } = record;
      const isoDate = this.$dateToISO(accounting_entry_date);
      return `${ID_Accounting_item.toLowerCase()}_${isoDate}`;
    },
    getCurrentPageData(pagesData, increment = 1) {
      const currPage = pagesData[pagesData.length - 1];

      // create new page when limit is reached
      if (currPage.length + increment > this.maxRowsPerPage) {
        pagesData.push([]);
        return pagesData[pagesData.length - 1];
      }
      return currPage;
    },
    addTotalsRecord(pagesData, totals) {
      const currPage = this.getCurrentPageData(pagesData, 1);
      currPage.push({ type: "totals", data: this.$clone(totals) });
    },
    reserveLastPageFooterSpace(pagesData) {
      const lastPage = pagesData[pagesData.length - 1];

      if (!lastPage || lastPage.length <= this.lastPageMaxRows) {
        return pagesData;
      }

      const overflow = lastPage.splice(this.lastPageMaxRows);
      pagesData.push(overflow);

      return pagesData;
    },
    async calculatePagesOfDoc() {
      const accountHeaders = new Set();
      let records = this.dataProps.data.body;
      const totals = { debe: 0, haber: 0 };
      const pagesData = [[]];

      records = records.length ? records : [];

      // sort records by accounting entry
      records = records.sort((rec1, rec2) => {
        return this.getRecordID(rec1) > this.getRecordID(rec2) ? 1 : -1;
      });

      // group records by pages
      records.forEach((record) => {
        record.ID = this.getRecordID(record);

        // get current page
        let pageData = this.getCurrentPageData(pagesData, 0);

        if (!accountHeaders.has(record.ID)) {
          // add totals for last accounting entry
          if (pageData.length) {
            this.addTotalsRecord(pagesData, totals);
            totals.debe = 0;
            totals.haber = 0;
          }

          // add headers for each accounting entry
          const { accounting_entry_date, ID_Accounting_item } = record;
          accountHeaders.add(record.ID);

          // get current page or create new (for an increment of 2 rows)
          pageData = this.getCurrentPageData(pagesData, 2);

          // add accounting entry header record
          pageData.push({
            type: "header",
            data: { accounting_entry_date, ID_Accounting_item },
          });
        }
        // get current page or create new (for an increment of 1 rows)
        pageData = this.getCurrentPageData(pagesData);
        pageData.push({ type: "child", data: record });

        // add values to totals
        totals.debe += parseFloat((record?.Debe || "0").replace("$", ""));
        totals.haber += parseFloat((record?.Haber || "0").replace("$", ""));
      });
      this.addTotalsRecord(pagesData, totals);
      this.reserveLastPageFooterSpace(pagesData);

      this.pagesData = pagesData;
      this.loading = false;
    },
  },
};
</script>
